import {darkThemeAdapterServicePrefix} from '../defaults'

export const getStyleSheetJSSelector = (name: string) => `${darkThemeAdapterServicePrefix}--${name}`
